(function () {
  document.querySelectorAll('[data-sv-accordion]').forEach(function (accordion) {
    var items = accordion.querySelectorAll('[data-sv-accordion-item]');

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  });
})();
